import { Metric, onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';

interface WebVitalsMetric extends Metric {
  url?: string;
  userAgent?: string;
}

// Track Web Vitals and send to analytics
export const trackWebVitals = () => {
  const sendToAnalytics = (metric: WebVitalsMetric) => {
    // Add URL and user agent for context
    const enhancedMetric = {
      ...metric,
      url: window.location.href,
      userAgent: navigator.userAgent,
    };

    // Log to console in development
    if (import.meta.env.DEV) {
      console.log(`🚀 Web Vital: ${metric.name}`, enhancedMetric);
    }

    // In production, send to your analytics service
    // Example: analytics.track('web_vital', enhancedMetric);
  };

  // Track all Core Web Vitals
  onCLS(sendToAnalytics);
  onFCP(sendToAnalytics);
  onINP(sendToAnalytics); // INP replaced FID in latest web-vitals
  onLCP(sendToAnalytics);
  onTTFB(sendToAnalytics);
};

// Performance budget thresholds
export const PERFORMANCE_BUDGETS = {
  LCP: 2500, // Largest Contentful Paint should be under 2.5s
  INP: 200,  // Interaction to Next Paint should be under 200ms
  CLS: 0.1,  // Cumulative Layout Shift should be under 0.1
  FCP: 1800, // First Contentful Paint should be under 1.8s
  TTFB: 800, // Time to First Byte should be under 800ms
};

// Check if metrics meet our performance budgets
export const checkPerformanceBudget = (metric: Metric): boolean => {
  const threshold = PERFORMANCE_BUDGETS[metric.name as keyof typeof PERFORMANCE_BUDGETS];
  return threshold ? metric.value <= threshold : true;
};